import "./login.css";
import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faUser } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { signIn } from "src/Thunk/adminThunks";
import { clearError, clearMsg } from "src/Actions/Admin/adminActions";
const MySwal = withReactContent(Swal);
const Login = () => {
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { error, msg } = useSelector((state) => state.admin);

  useEffect(() => {
    if (error) {
      MySwal.fire({
        icon: "error",
        title: error,
      });
      setTimeout(() => {
         dispatch(clearError())
      },1200)
    }
    if (msg) {
      navigate("/dashboard");
    }
  }, [error, msg]);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (data) => {
    dispatch(signIn(data));
  };
  return (
    <div className="authentication-bg d-flex align-items-center justify-content-center w-100 vh-100">
      <form className="form_container" onSubmit={handleSubmit(onSubmit)}>
        <img
          src={logo}
          className="w-40"
          style={{ height: "70px" }}
          alt="Logo"
        />
        <div className="title_container">
          <span className="subtitle mb-3">
            Sign in to continue to DBA Ago Sibillo.
          </span>
        </div>

        <div className="input_container mb-3">
          <label className="input_label" htmlFor="username_field">Username</label>
          <div className="password_input">
            <input
              type="text"
              {...register("username", { required: "username is required" })}
              className="input_field"
              placeholder="Username"
            />

            <FontAwesomeIcon icon={faUser} style={{position:"absolute", left:"20px", top:"16px"}} />
          </div>

          {errors.username && (
            <p className="text-danger text-left">{errors.username.message}</p>
          )}
        </div>

        <div className="input_container mb-3">
          <label className="input_label" htmlFor="password_field">
            Password
          </label>
          <div className="password_input">
            <input
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 8,
                  message: "Password must be at least 8 characters long",
                },
                maxLength: {
                  value: 15,
                  message: "Password must not exceed 15 characters",
                },
              })}
              type={showPassword ? "text" : "password"}
              className="input_field"
              placeholder="Password"
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              className="eye_button"
            >
              {showPassword ? (
                <FontAwesomeIcon icon={faEyeSlash} />
              ) : (
                <FontAwesomeIcon icon={faEye} />
              )}
            </button>
          </div>
          {errors.password && (
            <p className="text-danger">{errors.password.message}</p>
          )}
        </div>
        <button
          title="Sign In"
          type="submit"
          className="btn btn-primary w-100  mb-5"
        >
          <span>Log In</span>
        </button>
      </form>
      <div className="footer_text">
        <div className="input_label">
          &copy; Copyright {new Date().getFullYear()}, DBA Ago Sibillo. All
          Rights Reserved.
        </div>
      </div>
    </div>
  );
};

export default Login;
